// routes/OrdenesTrabajoRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import BuscarClienteOrdenTrabajo from "../pages/BuscarClienteOrdenTrabajo";
import CrearOrdenPage from "../pages/CrearOrdenPage";
import OrdenTrabajoDetalle from "../pages/OrdenTrabajoDetalle"
import OrdenTrabajoPaso from "../pages/OrdenTrabajoPaso"


const OrdenesTrabajoRoutes = () => {
  return (
      <Routes>
        <Route path="" element={<BuscarClienteOrdenTrabajo />} />
        <Route path="nueva" element={<CrearOrdenPage />} />
        <Route path="ot/:id" element={<OrdenTrabajoDetalle />} />
        <Route path="ot/:id/paso" element={<OrdenTrabajoPaso />} />
      </Routes>
  );
};

export default OrdenesTrabajoRoutes;
